import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'

import {
  TwitterShareButton,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton
} from 'react-share'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import * as AnalyticsReducer from '../reducers/analytics'
import Button from './Button'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import EmailIcon from '@material-ui/icons/Email'
import CloseIcon from '@material-ui/icons/Close'

import { isMobile } from '../config'
import { builder, BuilderComponent } from '@builder.io/react'
import colors from '@fe/ui/colors'

builder.init('32eea804311a4d17817f2e534ded7af8')

export const copyToClipboardFallback = ref => {
  try {
    ref.current.select()
    document.execCommand('copy')
  } catch (err) {
    console.warn(err)
  }
}

const ensureTagSymbol = (tag, present) => {
  if (!tag || !_.isString(tag)) {
    return tag
  }
  const hasSymbol = tag[0] === '#'
  const shouldAddSymbol = present && !hasSymbol
  const shouldRemoveSymbol = hasSymbol && !present

  if (shouldAddSymbol) {
    return '#' + tag
  } else if (shouldRemoveSymbol) {
    return tag.slice(1) // Drop the first char
  }
  return tag
}

const ShareButton = ({ shareData, shareOpen, shareClose, dialogTitle, ...props }) => {
  const [showDialog, setShowDialog] = React.useState(false)

  const handleClick = () => {
    shareOpen({ label: 'GLFR_OPEN__share_button' })
    isMobile && navigator.share
      ? navigator.share(shareData)
      : setShowDialog(true)
  }

  const handleClose = () => setShowDialog(false)

  const doShareOpen = label => () => shareOpen({ label: `GLFR_OPEN__${label}` })
  const doShareClose = label => () => {
    shareClose({ label: `GLFR_OPEN__${label}` })
    handleClose()
  }

  const handleCopyClick = _e => {
    if (!navigator.clipboard) {
      return copyToClipboardFallback(urlInputRef)
    }
    navigator.clipboard.writeText(shareData.url).catch(_err => copyToClipboardFallback(urlInputRef))
  }
  const urlInputRef = React.useRef()

  // Facebook expects a singe hashtag with the hash symbol (#) included
  // Twitter expects a list of hashtags without the hash symbol
  const facebookHashtag = ensureTagSymbol(shareData.hashtag, true)
  const twitterHashtags = shareData.hashtags || [ensureTagSymbol(shareData.hashtag, false)]

  return (
    <>
      <Button onClick={handleClick} {...props} style={{ display: 'flex', justifyContent: 'center', alignItem: 'center' }} />
      <Dialog onClose={handleClose} open={showDialog}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <Button style={{ position: 'absolute', right: 0, top: 0, height: 40, width: 40, color: colors.secondaryDarkGrey }} component={CloseIcon} fontSize='48' onClick={handleClose}>Kopier</Button>
          <BuilderComponent
            model='content-sections'
            entry='465cfd3bab3a4e3e8a7aa099d8e952f4'
          />
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <TwitterShareButton
              onShareWindowClose={doShareClose('twitter')}
              beforeOnClick={doShareOpen('twitter')}
              style={{ margin: 10 }}
              url={shareData.url}
              title={shareData.title}
              hashtags={twitterHashtags}
            >
              <TwitterIcon size={42} round />
            </TwitterShareButton>

            <FacebookShareButton
              onShareWindowClose={doShareClose('facebook')}
              beforeOnClick={doShareOpen('facebook')}
              quote={shareData.title}
              hashtag={facebookHashtag}
              style={{ margin: 10 }}
              url={shareData.url}
            >
              <FacebookIcon size={42} round />
            </FacebookShareButton>

            <FacebookMessengerShareButton
              onShareWindowClose={doShareClose('facebook-messenger')}
              beforeOnClick={doShareOpen('facebook-messenger')}
              style={{ margin: 10 }}
              appId='1020695051398914'
              url={shareData.url}
            >
              <FacebookMessengerIcon size={42} round />
            </FacebookMessengerShareButton>

            <EmailShareButton {...shareData}>
              <Button fontSize='inherit' component={EmailIcon} style={{ height: '100%' }} />
            </EmailShareButton>

            <Button style={{ height: '100%' }} component={FileCopyIcon} fontSize='48' onClick={handleCopyClick}>Kopier</Button>
          </div>

          <input style={{ width: '100%', fontSize: 16 }} readOnly value={shareData.url} ref={urlInputRef} />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default connect(
  null,
  {
    shareOpen: AnalyticsReducer.actions.shareOpen,
    shareClose: AnalyticsReducer.actions.shareClose
  }
)(ShareButton)
